export const getRootModel = (field: any) =>
  field?.model ? field.model.split('.')[0] : '';
